export { LoyaltyIconSgReward } from './LoyaltyIconSgReward';
